/**
 * Binds one invite suggestion to the keyed select handler (SE-8313).
 * @module features/scouting/components/molecules/ShareInviteRow/ShareCandidateRow/ShareCandidateRowContainer
 */

import { useCallback } from "react";

import ShareCandidateRowView from "./ShareCandidateRowView";

/** Props for `ShareCandidateRowContainer`. */
export interface ShareCandidateRowContainerProps {
  /** User id. */
  readonly userId: string;
  /** Display name. */
  readonly name: string;
  /** Select handler keyed by user id. */
  readonly onSelect: (userId: string) => void;
}

/**
 * Renders one suggestion with its handler bound to the user id.
 * @param root0 - Component props
 * @param root0.userId - User id
 * @param root0.name - Display name
 * @param root0.onSelect - Select handler keyed by user id
 * @returns The bound suggestion row.
 */
const ShareCandidateRowContainer = ({
  userId,
  name,
  onSelect,
}: ShareCandidateRowContainerProps) => {
  const handlePress = useCallback(() => {
    onSelect(userId);
  }, [onSelect, userId]);

  return (
    <ShareCandidateRowView userId={userId} name={name} onPress={handlePress} />
  );
};

ShareCandidateRowContainer.displayName = "ShareCandidateRowContainer";

export default ShareCandidateRowContainer;
